export const OPERATOR_AUTH_STORAGE_KEY = "authToken"
export const OPERATOR_PROFILE_STORAGE_KEY = "userInfo"

export interface OperatorSessionSnapshot {
  token: string | null
  hasProfileCache: boolean
  profileCache: unknown | null
}

export function getOperatorSessionSnapshot(): OperatorSessionSnapshot {
  if (typeof window === "undefined") {
    return {
      token: null,
      hasProfileCache: false,
      profileCache: null,
    }
  }

  const token = window.localStorage.getItem(OPERATOR_AUTH_STORAGE_KEY)
  const profileCacheRaw = window.localStorage.getItem(OPERATOR_PROFILE_STORAGE_KEY)

  let profileCache: unknown | null = null

  if (profileCacheRaw) {
    try {
      profileCache = JSON.parse(profileCacheRaw)
    } catch {
      profileCache = profileCacheRaw
    }
  }

  return {
    token,
    hasProfileCache: profileCacheRaw !== null,
    profileCache,
  }
}

export function getOperatorAuthorizationHeader(): string | null {
  return null
}

export function setOperatorAuthToken(token: string | null) {
  void token
}

export function getOperatorProfileCache<TProfile>(): TProfile | null {
  return null
}

export function setOperatorProfileCache(profile: unknown) {
  void profile
}

export function clearOperatorSession() {}
